import { render } from "./casualQues.vue?vue&type=template&id=c2343db8"
import script from "./casualQues.vue?vue&type=script&lang=js"
export * from "./casualQues.vue?vue&type=script&lang=js"

import "./casualQues.vue?vue&type=style&index=0&id=c2343db8&lang=scss"
script.render = render

export default script